// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1zITR","link":"link-2eJ8I"};